import React from "react";
import { Menu, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/20/solid";
import { SectionTemplateType } from "../../../../../src/js/polaris/util/privacyCenterUtil";
import { AddSectionButtonAction } from "../../../../../src/js/polaris/components/privacyCenter/EditPrivacyCenter";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export interface NewSectionDropdownTemplate {
  label: string;
  sectionType: SectionTemplateType;
  templateGroup: "Core" | "International";
}

export default function AddNewSectionDropdown({
  buttonText,
  dropdownOptions,
  onClickHandler,
}: {
  buttonText: string;
  dropdownOptions: NewSectionDropdownTemplate[];
  onClickHandler: (addSectionAction: AddSectionButtonAction) => void;
}) {
  const coreTemplateOptions = dropdownOptions.filter((d) => d.templateGroup == "Core");
  const internationalTemplateOptions = dropdownOptions.filter(
    (d) => d.templateGroup == "International",
  );

  return (
    <Menu as="div" className="relative inline-block text-left" style={{ zIndex: 110 }}>
      <div>
        <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-6 py-3 text-base font-medium text-neutral-800 shadow-sm ring-1 ring-inset ring-gray-300 items-center hover:bg-gray-50">
          {buttonText}
          <PlusIcon className="-mr-1 h-5 w-5 text-[#0F172A]" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-[-43px] z-10 mt-2 w-[359px] origin-top-right rounded-md bg-white shadow-lg focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active, close }) => (
                <a
                  href="#"
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-[rgba(0,0,0,0.87)]",
                    "block px-4 py-2 text-base",
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClickHandler("Blank");
                    close();
                  }}
                >
                  Blank Section
                </a>
              )}
            </Menu.Item>
            <hr style={{ borderTop: "1px solid rgba(33, 33, 33, 0.08)" }} />
            <div className="flex justify-between items-center">
              <div
                className="text-primary-800 font-bold text-xs pl-3.5 py-2 leading-6 tracking-wider"
                style={{ textTransform: "uppercase" }}
              >
                Core Templates
              </div>
              <div
                className="inline-flex items-center cursor-pointer border border-solid border-neutral-300 rounded-[100px] px-[10px] py-[5px] mr-3.5"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClickHandler("ADD_ALL_CORE_SECTIONS");
                }}
              >
                <PlusIcon className="w-4 h-4 text-neutral-500" />
                <span className="text-neutral-800 text-xs ml-1">Add All</span>
              </div>
            </div>
            {coreTemplateOptions.map((option, idx) => {
              return (
                <Menu.Item key={idx}>
                  {({ active, close }) => (
                    <a
                      href="#"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-[rgba(0,0,0,0.87)]",
                        "block pl-[26px] py-2 text-base",
                      )}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onClickHandler(option.sectionType);
                        close();
                      }}
                    >
                      {option.label}
                    </a>
                  )}
                </Menu.Item>
              );
            })}
            {internationalTemplateOptions.length > 0 && (
              <>
                <hr style={{ borderTop: "1px solid rgba(33, 33, 33, 0.08)" }} />
                <div
                  className="text-primary-800 font-bold text-xs pl-3.5 py-2 leading-6 tracking-wider"
                  style={{ textTransform: "uppercase" }}
                >
                  International Templates
                </div>
                {internationalTemplateOptions.map((option, idx) => {
                  return (
                    <Menu.Item key={idx}>
                      {({ active, close }) => (
                        <a
                          href="#"
                          className={classNames(
                            active ? "bg-gray-100 text-gray-900" : "text-[rgba(0,0,0,0.87)]",
                            "block pl-[26px] py-2 text-base",
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClickHandler(option.sectionType);
                            close();
                          }}
                        >
                          {option.label}
                        </a>
                      )}
                    </Menu.Item>
                  );
                })}
              </>
            )}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
